import React from "react";
import { TbLivePhoto } from "react-icons/tb";

function LiveButton() {
  return (
    <div className="absolute top-2 left-2 z-10 flex items-center gap-1 rounded-md bg-[var(--red)] px-2 py-1 shadow-lg shadow-[var(--red)]/30">
      {/* <TbLivePhoto className="text-white animate-ping" /> */}
      <p className="text-xs font-semibold text-white">LIVE</p>
    </div>
  );
}

export default LiveButton;